import React from 'react';
import { Heading, Paragraph } from 'bumbag';

import LandingPage from '@medipass/react-core/Layout/LandingPage';

import { getKeyFromQueryParams } from 'legacy/utils/router';
type Props = {};
type State = {
  error?: string;
};
export default class Error extends React.Component<Props, State> {
  state = {
    error: getKeyFromQueryParams('error'),
  };
  render = () => {
    const { error } = this.state;
    return (
      <LandingPage title="An error occurred">
        <Heading fontSize="400" paddingBottom="major-2">
          Something went wrong...
        </Heading>
        {error && <Paragraph>{error}</Paragraph>}
      </LandingPage>
    );
  };
}
